export default __webpack_public_path__ + "static/media/DA_onboarding_photo.3945d91b.jpg";